import { Component, OnInit, Input } from '@angular/core';
import { AppDataService } from 'app/services';
import { OperatorVehiclesService } from 'app/services/operator/operator-vehicles.service';
import { MessageService } from 'primeng/api';
import { OperatorVehicleTab } from 'app/models/operator/operator-vehicles-query.model';

@Component({
    selector: 'operator-vehicles',
    templateUrl: './operator-vehicles.component.html',
    styleUrls: ['./operator-vehicles.component.scss',
        '../../../../../styles/menu-sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
})
export class OperatorVehiclesComponent implements OnInit {
    constructor(
        private messageService: MessageService,
        public appData: AppDataService,
        private operatorVehiclesService: OperatorVehiclesService
    ) { }

    public visibleAddOperatorVehicle: boolean = false;

    @Input()
    public menuPermissionActive!: string;

    public operatorVehicles!: any;
    public vehicleTotal: number = 0;
    public visibleVehicleDetail: boolean = false;

    public selectVehicleId!: number;

    public isLoading: boolean = false;
    public menuVehicleActive: OperatorVehicleTab = OperatorVehicleTab.Active;
    public visibleAddDriversToVhicle: boolean = false;

    ngOnInit(): void {
        this.getOperatorVehicles();
    }

    public openAddDriversDialog(vehicleId: number) {
        this.selectVehicleId = vehicleId;
        this.visibleAddDriversToVhicle = true;
    }

    changedVisibleAddDriversToVhicleEmit(value: boolean) {
        this.visibleAddDriversToVhicle = value;
    }

    openAddOperatorVehicle() {
        this.visibleAddOperatorVehicle = true;
    }

    changedOpenAddOperatorVehicleEmit(value: boolean | { added: true }) {
        this.visibleAddOperatorVehicle = false;
        if (typeof value === 'object' && value?.added) {
            // Newly added vehicles are Pending Review and appear under Inactive
            this.menuVehicleActive = OperatorVehicleTab.Inactive;
        }
        this.getOperatorVehicles();
    }

    private getOperatorVehicles() {
        this.isLoading = true;

        this.operatorVehiclesService.getVehicles({
            isActive: this.menuVehicleActive === OperatorVehicleTab.Active
        }, this.messageService)
            .then(result => {
                this.operatorVehicles = result.items;
                this.vehicleTotal = result.totalRecords;
                this.isLoading = false;
            })
            .catch(err => {
                this.isLoading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: err?.message ?? 'Failed to load vehicles'
                });
            });
    }

    public openVehicleDetail(vehicleId: number) {
        this.visibleVehicleDetail = true;
        this.selectVehicleId = vehicleId;
    }

    changedAddOperatorVehicleDetailEmit(value: boolean) {
        this.visibleVehicleDetail = value;
        this.getOperatorVehicles();
    }

    handleTabChange(value: number) {
        this.menuVehicleActive = value as OperatorVehicleTab;
        this.getOperatorVehicles();
    }

    public getApprovalStatus(vehicle: { Status?: string }): 'Pending' | 'Approved' | 'Rejected' {
        const status = (vehicle?.Status || '').trim();
        if (status === 'Approved') {
            return 'Approved';
        }
        if (status === 'Rejected') {
            return 'Rejected';
        }
        return 'Pending';
    }

    public getApprovalStatusIconSrc(vehicle: { Status?: string }): string | null {
        const status = this.getApprovalStatus(vehicle);
        if (status === 'Pending') {
            return '../Content/xpress-app/images/operator/pending-review.svg';
        }
        if (status === 'Rejected') {
            return '../Content/xpress-app/images/operator/rejected.svg';
        }
        return null;
    }

    public getApprovalStatusLabel(vehicle: { Status?: string }): string {
        const status = this.getApprovalStatus(vehicle);
        if (status === 'Pending') {
            return 'Pending Review';
        }
        return status;
    }

    public getAssignedDriversLabel(vehicle: { AssignedDriverNames?: string[] }): string {
        const names = (vehicle?.AssignedDriverNames ?? []).filter(name => !!name?.trim());
        if (names.length === 0) {
            return 'None';
        }
        return names.join(', ');
    }
}
